/* Pommeau de vitesse - scripts v2 */
(function () {
  'use strict';
  var d = document;
  var qs = function (s, c) { return (c || d).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };

  /* ---------- Format monetaire (reprend le format de la boutique) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.PDV && window.PDV.moneyFormat) || '{{amount_with_comma_separator}} €';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, dec, ts, ds) {
      dec = isNaN(dec) ? 2 : dec;
      var num = (n / 100).toFixed(dec);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts);
      return dollars + (parts[1] ? ds + parts[1] : '');
    }
    var v = '';
    switch (m ? m[1] : 'amount_with_comma_separator') {
      case 'amount': v = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return m ? format.replace(m[0], v) : v;
  }
  window.PDV = window.PDV || {};
  window.PDV.formatMoney = formatMoney;

  /* ---------- En-tete : ombre au defilement + hauteur ---------- */
  var header = qs('[data-pdv-header]');
  function setHeaderH() {
    if (header) d.documentElement.style.setProperty('--pdv-header-h', header.offsetHeight + 'px');
    var ann = qs('.pdv-announce');
    d.documentElement.style.setProperty('--pdv-announce-h', (ann ? ann.offsetHeight : 0) + 'px');
  }
  if (header) {
    setHeaderH();
    window.addEventListener('resize', setHeaderH);
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu deroulant (ordinateur) ---------- */
  var navItems = qsa('[data-pdv-nav-item]');
  function closeAll(except) {
    navItems.forEach(function (it) {
      if (it !== except) {
        it.classList.remove('is-open');
        var b = qs('[data-pdv-nav-toggle]', it);
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }
  navItems.forEach(function (item) {
    var btn = qs('[data-pdv-nav-toggle]', item);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = !item.classList.contains('is-open');
      closeAll(item);
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    item.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover:hover)').matches) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
  d.addEventListener('click', function (e) {
    if (!e.target.closest('[data-pdv-nav-item]')) closeAll();
  });

  /* ---------- Tiroir mobile ---------- */
  var drawer = qs('[data-pdv-drawer]');
  var overlay = qs('[data-pdv-overlay]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = d.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    d.body.classList.add('pdv-lock');
    qsa('[data-pdv-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = qs('[data-pdv-drawer-close]', drawer);
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    d.body.classList.remove('pdv-lock');
    qsa('[data-pdv-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  qsa('[data-pdv-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  qsa('[data-pdv-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeAll(); }
  });

  /* ---------- Recherche mobile ---------- */
  var msearch = qs('#pdv-msearch');
  qsa('[data-pdv-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!msearch) return;
      var open = b.hasAttribute('data-pdv-search-focus') ? true : !msearch.classList.contains('is-open');
      msearch.classList.toggle('is-open', open);
      qsa('[data-pdv-search-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        var input = qs('input[type=search]', msearch);
        if (input) setTimeout(function () { input.focus(); }, 150);
      }
      setHeaderH();
    });
  });

  /* ---------- Pied de page : colonnes repliees sur mobile ---------- */
  if (window.matchMedia('(max-width:749px)').matches) {
    qsa('[data-pdv-footer-details]').forEach(function (el) { el.removeAttribute('open'); });
  }

  /* ---------- Carrousels ---------- */
  qsa('[data-pdv-slider]').forEach(function (root) {
    var track = qs('.pdv-slider__track', root);
    var prev = qs('[data-pdv-prev]', root.parentNode) || qs('[data-pdv-prev]', root);
    var next = qs('[data-pdv-next]', root.parentNode) || qs('[data-pdv-next]', root);
    var scope = root.closest('[data-pdv-slider-scope]');
    if (scope) { prev = qs('[data-pdv-prev]', scope); next = qs('[data-pdv-next]', scope); }
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Lire la suite ---------- */
  qsa('[data-pdv-readmore]').forEach(function (root) {
    var content = qs('.pdv-readmore__content', root);
    var btn = qs('.pdv-readmore__btn', root);
    if (!content || !btn) return;
    var limit = parseInt(root.getAttribute('data-pdv-readmore'), 10) || 360;
    if (content.scrollHeight <= limit + 80) { btn.hidden = true; return; }
    root.style.setProperty('--pdv-clamp', limit + 'px');
    root.classList.add('is-clamped');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var clamped = root.classList.toggle('is-clamped');
      btn.textContent = clamped ? (btn.getAttribute('data-more') || 'Lire la suite') : (btn.getAttribute('data-less') || 'Réduire');
      btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
    });
  });

  /* ---------- Tri des collections ---------- */
  qsa('[data-pdv-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Fiche produit ---------- */
  qsa('[data-pdv-product]').forEach(function (root) {
    var dataEl = qs('script[data-pdv-variants]', root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = qs('form[data-pdv-form]', root);
    var idInput = form ? qs('input[name=id]', form) : null;
    var atc = qs('[data-pdv-atc]', root);
    var atcLabel = qs('[data-pdv-atc-label]', root);
    var priceNow = qsa('[data-pdv-price-now]', root);
    var priceWas = qsa('[data-pdv-price-was]', root);
    var saveEl = qs('[data-pdv-save]', root);
    var stockEl = qs('[data-pdv-stock]', root);
    var skuEl = qs('[data-pdv-sku]', root);
    var sticky = qs('[data-pdv-sticky]', root);
    var stickyBtn = sticky ? qs('[data-pdv-sticky-atc]', sticky) : null;
    var track = qs('.pdv-gallery__track', root);
    var thumbs = qsa('[data-pdv-thumb]', root);
    var counter = qs('[data-pdv-counter]', root);
    var slides = track ? qsa('.pdv-gallery__slide', track) : [];

    function currentOptions() {
      return qsa('[data-pdv-option]', root).map(function (fs) {
        var c = qs('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    var currentIndex = 0;
    function jumpTo(index) {
      if (!track || !slides[index]) return;
      var sb = track.style.scrollBehavior, st = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto'; track.style.scrollSnapType = 'none';
      track.scrollLeft = slides[index].offsetLeft;
      track.style.scrollSnapType = st; track.style.scrollBehavior = sb;
      currentIndex = index;
    }
    function goToSlide(index, smooth) {
      if (!track || !slides[index]) return;
      if (smooth === false) { jumpTo(index); return; }
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); if (i === index) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      var t = thumbs[index];
      if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
    }
    function updateAvailability(opts) {
      qsa('[data-pdv-option]', root).forEach(function (fs, idx) {
        qsa('.pdv-pill', fs).forEach(function (pill) {
          var input = qs('input', pill);
          var test = opts.slice(); test[idx] = input.value;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
        var sel = qs('[data-pdv-option-value]', fs);
        var c = qs('input:checked', fs);
        if (sel && c) sel.textContent = c.value;
      });
    }
    function render(v, fromUser) {
      var opts = currentOptions();
      updateAvailability(opts);
      if (!v) {
        if (atc) { atc.disabled = true; }
        if (atcLabel) atcLabel.textContent = 'Indisponible';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      priceNow.forEach(function (el) { el.textContent = formatMoney(v.price); el.classList.toggle('is-sale', v.compare_at_price > v.price); });
      priceWas.forEach(function (el) { if (v.compare_at_price > v.price) { el.textContent = formatMoney(v.compare_at_price); el.hidden = false; } else { el.hidden = true; } });
      if (saveEl) {
        if (v.compare_at_price > v.price) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          saveEl.innerHTML = '-' + pct + ' % <span>soit ' + formatMoney(v.compare_at_price - v.price) + ' d’économie</span>';
          saveEl.hidden = false;
        } else { saveEl.hidden = true; }
      }
      if (stockEl) {
        stockEl.classList.toggle('is-out', !v.available);
        stockEl.textContent = v.available ? (stockEl.getAttribute('data-in') || 'En stock') : (stockEl.getAttribute('data-out') || 'Indisponible');
      }
      if (skuEl) { skuEl.textContent = v.sku || ''; skuEl.parentNode.hidden = !v.sku; }
      if (atc) atc.disabled = !v.available;
      qsa('[data-pdv-buynow]', root).forEach(function (b) { b.disabled = !v.available; });
      if (atcLabel) atcLabel.textContent = v.available ? (atcLabel.getAttribute('data-label') || 'Ajouter au panier') : 'Indisponible';
      if (stickyBtn) { stickyBtn.disabled = !v.available; }
      if (fromUser && v.media_index !== null && v.media_index !== undefined) goToSlide(v.media_index);
      if (fromUser && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('pdv:variant', { detail: v, bubbles: true }));
    }
    qsa('[data-pdv-option] input', root).forEach(function (input) {
      input.addEventListener('change', function () { render(findVariant(currentOptions()), true); });
    });
    render(findVariant(currentOptions()), false);

    /* Galerie */
    if (track && slides.length) {
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToSlide(i); }); });
      var prev = qs('[data-pdv-gprev]', root), next = qs('[data-pdv-gnext]', root);
      function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
      if (prev) prev.addEventListener('click', function () { goToSlide(Math.max(0, idx() - 1)); });
      if (next) next.addEventListener('click', function () { goToSlide(Math.min(slides.length - 1, idx() + 1)); });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = idx();
          currentIndex = i;
          setActiveThumb(i);
          if (prev) prev.disabled = i <= 0;
          if (next) next.disabled = i >= slides.length - 1;
        });
      }, { passive: true });
      var start = parseInt(track.getAttribute('data-start') || '0', 10);
      if (start > 0) jumpTo(start);
      window.addEventListener('load', function () { jumpTo(currentIndex); });
      window.addEventListener('resize', function () { jumpTo(currentIndex); });
      setActiveThumb(start);
      if (prev) prev.disabled = start <= 0;
      if (next) next.disabled = start >= slides.length - 1;
    }

    /* Quantite */
    qsa('[data-pdv-qty]', root).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          val = b.hasAttribute('data-plus') ? val + 1 : Math.max(1, val - 1);
          input.value = val;
        });
      });
    });

    /* Barre d'achat fixe : visible quand le bouton principal est passe au-dessus de l'ecran */
    if (sticky && atc) {
      var stickyRaf;
      var checkSticky = function () {
        var show = atc.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        d.body.classList.toggle('pdv-sticky-on', show);
      };
      window.addEventListener('scroll', function () { cancelAnimationFrame(stickyRaf); stickyRaf = requestAnimationFrame(checkSticky); }, { passive: true });
      window.addEventListener('resize', checkSticky);
      checkSticky();
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form && form.requestSubmit && atc && !atc.disabled) { form.requestSubmit(atc); }
        else { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    }
  });

  /* ---------- Panier : mise a jour automatique des quantites ---------- */
  qsa('[data-pdv-cart-form]').forEach(function (form) {
    var btn = qs('[data-pdv-cart-update]', form);
    if (btn) btn.hidden = true;
    var timer;
    function submitSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        form.classList.add('is-loading');
        if (btn && form.requestSubmit) { btn.hidden = false; form.requestSubmit(btn); }
        else { var h = d.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1'; form.appendChild(h); form.submit(); }
      }, 650);
    }
    qsa('[data-pdv-cart-qty]', form).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          input.value = b.hasAttribute('data-plus') ? v + 1 : Math.max(0, v - 1);
          submitSoon();
        });
      });
      input.addEventListener('change', submitSoon);
    });
  });

  /* ---------- Article : sommaire automatique et copie du lien ---------- */
  qsa('[data-pdv-toc]').forEach(function (toc) {
    var content = qs('[data-pdv-article-content]');
    if (!content) return;
    var heads = qsa('h2', content);
    if (heads.length < 2) return;
    var list = qs('ol', toc), used = {};
    heads.forEach(function (h) {
      var base = (h.id || h.textContent).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'partie';
      var id = base, n = 2;
      while (used[id] || (d.getElementById(id) && d.getElementById(id) !== h)) { id = base + '-' + n++; }
      used[id] = true; h.id = id;
      var li = d.createElement('li'), a = d.createElement('a');
      a.href = '#' + id; a.textContent = h.textContent.trim();
      li.appendChild(a); list.appendChild(li);
    });
    toc.hidden = false;
    var tocTitle = qs(".pdv-toc__title", toc);
    if (tocTitle) {
      tocTitle.setAttribute("role", "button"); tocTitle.setAttribute("tabindex", "0"); tocTitle.setAttribute("aria-expanded", "false");
      var toggleToc = function () { var o = toc.classList.toggle("is-open"); tocTitle.setAttribute("aria-expanded", o ? "true" : "false"); };
      tocTitle.addEventListener("click", toggleToc);
      tocTitle.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggleToc(); } });
    }
    if ('IntersectionObserver' in window) {
      var links = qsa('a', list);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + en.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  });
  qsa('[data-pdv-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-pdv-copy'), label = qs('[data-pdv-copy-label]', b);
      var done = function () { if (label) { label.textContent = 'Lien copié'; setTimeout(function () { label.textContent = 'Copier le lien'; }, 2000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done); else done();
    });
  });

  /* ---------- Toutes les collections : raccourcis vers les rubriques ---------- */
  qsa('[data-pdv-colnav]').forEach(function (nav) {
    qsa('.pdv-colgroup').forEach(function (g) {
      var h = qs('h2', g);
      if (!h || !g.id) return;
      var a = d.createElement('a');
      a.className = 'pdv-chip'; a.href = '#' + g.id; a.textContent = h.textContent.trim(); a.setAttribute('role', 'listitem');
      nav.appendChild(a);
    });
  });

  /* ---------- Ajout rapide au panier (cartes produit des articles) ---------- */
  function setCartCount(n) {
    qsa('.pdv-header a[href*="/cart"], .pdv-tabbar a[href*="/cart"]').forEach(function (a) {
      var c = qs('.pdv-count', a);
      if (!c && n > 0) { c = d.createElement('span'); c.className = 'pdv-count'; a.appendChild(c); }
      if (c) { if (n > 0) { c.textContent = n; } else { c.remove(); } }
    });
  }
  var toastTimer;
  function toast(ok, text) {
    var t = qs('.pdv-toast');
    if (!t) { t = d.createElement('div'); t.className = 'pdv-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.className = 'pdv-toast is-visible' + (ok ? '' : ' is-error');
    t.innerHTML = ok ? '<span>\u2713 ' + text + '</span><a href="/cart">Voir le panier</a>' : '<span>' + text + '</span>';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4500);
  }
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-pdv-quickadd]');
    if (!f || !window.fetch) return;
    e.preventDefault();
    var btn = qs('button[type=submit]', f);
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Ajout impossible');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { setCartCount(cart.item_count); toast(true, 'Ajouté au panier'); })
      .catch(function (err) { toast(false, err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Etoiles de secours (contenu charge apres la page) ---------- */
  function fallbackStars(scope) {
    qsa('.loox-rating', scope).forEach(function (r) {
      if (r.getAttribute('data-rating-upgraded') || r.children.length) return;
      var rating = parseFloat(r.getAttribute('data-rating')), n = parseInt(r.getAttribute('data-raters'), 10);
      if (!rating || !n) return;
      var star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>';
      var full = Math.round(rating), html = '<span class="pdv-stars" aria-label="' + rating + ' sur 5">';
      for (var i = 0; i < 5; i++) html += i < full ? star : star.replace('<path', '<path opacity=".25"');
      html += '<span>(' + n + ')</span></span>';
      r.innerHTML = html;
    });
  }

  /* ---------- Recommandations produit ---------- */
  qsa('[data-pdv-reco]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = d.createElement('div');
      tmp.innerHTML = html;
      var inner = qs('[data-pdv-reco]', tmp);
      if (inner && inner.innerHTML.trim().length) {
        el.innerHTML = inner.innerHTML;
        el.hidden = false;
        fallbackStars(el);
        d.dispatchEvent(new CustomEvent('pdv:reco-loaded'));
      }
    }).catch(function () {});
  });
})();

/* ---------- Bannière d'accueil : poussières dans le rayon de soleil ---------- */
(function () {
  var c = document.querySelector('[data-pdv-dust]');
  if (!c || !c.getContext) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ctx = c.getContext('2d'), parts = [], W = 0, H = 0, running = false, visible = true, raf = 0;

  function size() {
    var r = c.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    c.width = Math.round(W * dpr); c.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function spawn(p, first) {
    var mobile = W < 750, bx = W * (mobile ? 0.6 : 0.74), spread = W * (mobile ? 0.42 : 0.3);
    p.big = Math.random() < 0.15;
    p.x = bx + (Math.random() * 2 - 1) * spread;
    p.y = first ? Math.random() * H : H * (0.45 + Math.random() * 0.55);
    p.r = p.big ? 1.8 + Math.random() * 1.8 : 0.5 + Math.random() * 1.2;
    p.vx = Math.random() * 0.18 - 0.05;
    p.vy = -(0.04 + Math.random() * 0.16);
    p.max = p.big ? 0.12 + Math.random() * 0.12 : 0.3 + Math.random() * 0.5;
    p.life = 0; p.span = 700 + Math.random() * 900; p.ph = Math.random() * 6.28;
    return p;
  }
  function init() {
    size();
    var n = W < 750 ? 26 : 48;
    parts = [];
    for (var i = 0; i < n; i++) parts.push(spawn({}, true));
  }
  function frame() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      p.life++;
      p.x += p.vx + Math.sin(p.life / 110 + p.ph) * 0.07;
      p.y += p.vy;
      var fade = Math.min(1, p.life / 120, (p.span - p.life) / 160);
      if (fade <= 0 || p.y < -10) { spawn(p, false); continue; }
      var a = p.max * fade * (0.7 + 0.3 * Math.sin(p.life / 23 + p.ph));
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(255,222,170,' + a.toFixed(3) + ')';
      ctx.shadowColor = 'rgba(255,200,130,' + (a * 0.9).toFixed(3) + ')';
      ctx.shadowBlur = p.big ? 10 : 4;
      ctx.fill();
    }
    raf = window.requestAnimationFrame(frame);
  }
  function start() { if (!running && visible && !document.hidden) { running = true; raf = window.requestAnimationFrame(frame); } }
  function stop() { running = false; window.cancelAnimationFrame(raf); }

  init();
  start();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start(); else stop();
    }).observe(c);
  }
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(init, 200); });
})();

/* ---------- Bannière : cadran animé figé si l'utilisateur réduit les animations ---------- */
(function () {
  var g = document.querySelector('[data-pdv-gauge]');
  if (g && g.pauseAnimations && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) g.pauseAnimations();
})();
